const PARK_EXTENSION = 79000
const SLOT_HEADER = 'Parked-Slot'
const NUMBER_HEADER = 'Parked-Num'

export const parkedSlot2extension = (slot) =>
  PARK_EXTENSION + Number.parseInt(slot, 10)

export const extension2parkedSlot = (extension) => extension - PARK_EXTENSION

export const CSv3parkedFromHeaders = (headers) => {
  const rawSlot = headers?.[SLOT_HEADER]?.[0]?.raw
  const phone = headers?.[NUMBER_HEADER]?.[0]?.raw

  if (!(rawSlot && phone)) return undefined

  return {
    slot: extension2parkedSlot(Number.parseInt(rawSlot, 10)),
    rawSlot,
    phone,
  }
}
